document.addEventListener('DOMContentLoaded', function() {

	// HEADER SCROLL
	const body = document.querySelector('body');
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = document.getElementById('header').offsetHeight;

	window.onscroll = function() {
	    didScroll = true;
	};

	setInterval( function() {
	    if ( didScroll ) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250 );

	function hasScrolled() {
	    var st = window.pageYOffset | document.body.scrollTop;

	    if( Math.abs( lastScrollTop - st ) <= delta )
	        return;
	    if( st > lastScrollTop && st > navbarHeight ) {
	    	body.classList.remove('scroll-down');
	    	body.classList.add('scroll-up');
	    }
	    else {
	        if( st + window.innerHeight < document.body.scrollHeight ) {
		    	body.classList.remove('scroll-up');
		    	body.classList.add('scroll-down');
	        }
	    }

	    if( st > 0 ) {
	    	body.classList.add('scroll');
	    }
	    else {
	    	body.classList.remove('scroll');
	    }

	    lastScrollTop = st;
	}


	// MENU
	[].forEach.call( document.querySelectorAll('#header #nav ul li.menu-item-has-children'), function ( a ) {
	    a.addEventListener('mouseenter', function () {

			var windowWidth = window.innerWidth;
			if( windowWidth > 1023 ) {
				document.querySelector('body').classList.add('menu-opened');
				setTimeout(function(){
					a.classList.add("opened");
				}, 200);

			}

	    }, false );
	});

	[].forEach.call( document.querySelectorAll('#header #nav ul li.menu-item-has-children'), function ( a ) {
	    a.addEventListener('mouseleave', function () {

			var windowWidth = window.innerWidth;
			if( windowWidth > 1023 ) {
				a.classList.remove("opened");
				document.querySelector('body').classList.remove('menu-opened');
			}

	    }, false );
	});

	[].forEach.call( document.querySelectorAll('#header #nav ul li.menu-item-has-children > a'), function ( hasChildren ) {
	    hasChildren.addEventListener('click', function () {

			var windowWidth = window.innerWidth;
			if( windowWidth < 1024 ) {
				event.preventDefault();
				hasChildren.parentNode.classList.toggle("opened");
			}

	    })
	});


	document.querySelector('#toggle').addEventListener('click', function (event) {

		if (body.classList.contains('menu-opened')) {
			document.querySelector('#header nav > ul').classList.remove('show');
			setTimeout(function(){
				document.body.classList.remove('menu-opened');
			}, 200);
		}
		else {
			document.body.classList.add('menu-opened');
			setTimeout(function(){
				document.querySelector('#header nav > ul').classList.add('show');
			}, 200);
		}

	}, false);



	// TOGGLE
	[].forEach.call( document.querySelectorAll('.toggle_trigger'), function ( toggle ) {
	    toggle.addEventListener('click', function () {

			this.classList.toggle('active');
			toggle.nextElementSibling.classList.toggle("show");

	    })
	});

	[].forEach.call( document.querySelectorAll('.store h3 button'), function ( horaires ) {
	    horaires.addEventListener('click', function () {

			var dataHoraires = horaires.getAttribute('data-horaires');
			var classHoraires = '.horaires_'+dataHoraires;

			if( this.classList.contains("active") ) {
				this.classList.remove('active');
				document.querySelector(classHoraires).classList.remove('show');
			}
			else {
				Array.from(document.querySelectorAll('.store h3 button')).forEach(function(el) {
					el.classList.remove('active');
				});
				Array.from(document.querySelectorAll('.store .horaires')).forEach(function(el) {
					el.classList.remove('show');
				});

				this.classList.add('active');
				document.querySelector(classHoraires).classList.add('show');
			}

	    })
	});

	if (document.querySelector('.openCaracteristiques')) {
		document.querySelector('.openCaracteristiques').addEventListener('click', function (event) {

			document.querySelector('.openCaracteristiques').classList.add('hide');
			document.querySelector('.caracteristiques .max-height').classList.add('open');

		}, false);
	}

    if (document.querySelector('.openDescription')) {
		document.querySelectorAll('.openDescription').forEach((el) => {
            el.addEventListener('click', function (event) {
                document.querySelectorAll('.openDescription').forEach((elem) => {
                    elem.classList.remove('hide');
                    elem.parentElement.querySelector('.max-height').classList.remove('open');
                });
                el.classList.add('hide');
                el.parentElement.querySelector('.max-height').classList.add('open');

            }, false);
        })
	}


	// SAME HEIGHT HOME TESTI + ACTUS
	if (document.querySelector('.item.sameHeight')) {
		var sameHeight = document.querySelector('.item.sameHeight').clientHeight;
		[].forEach.call( document.querySelectorAll('.glide-actualites.sameHeight .actualite a'), function ( actualite ) {
			actualite.style.height = sameHeight+'px';
		});
	}


	// Smooth Scrolling
	if (document.querySelector('a.smooth')) {
		const links = document.querySelectorAll("a.smooth");

		for (const link of links) {
		link.addEventListener("click", clickHandler);
		}

		function clickHandler(e) {
		e.preventDefault();
		const href = this.getAttribute("href");
		const offsetTop = document.querySelector(href).offsetTop - 20;

		scroll({
			top: offsetTop,
			behavior: "smooth"
		});
		}
	}


});

window.addEventListener('resize', function(event) {

	// SAME HEIGHT HOME TESTI + ACTUS
	if (document.querySelector('.item.sameHeight')) {
		var sameHeight = document.querySelector('.item.sameHeight').clientHeight;
		[].forEach.call( document.querySelectorAll('.glide-actualites.sameHeight .actualite a'), function ( actualite ) {
			actualite.style.height = sameHeight+'px';
		});
	}

}, true);

